export interface Church {
  id: number;
  name: string;
  location: string;
  region: string;
  state: string;
  union: string;
  conference: string;
  status: string;
  hasWebsite: boolean;
  websiteUrl?: string;
  image: string;
  members: number;
  livestream: boolean;
  coordinates: { lat: number; lng: number };
  distance?: number;
}

export const churches: Church[] = [
  // Lagos State - Western Nigeria Union Conference (WNUC)
  {
    id: 1,
    name: 'Lagos Central SDA Church',
    location: 'Ikeja, Lagos State',
    region: 'South West',
    state: 'Lagos',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Lagos Mainland Conference',
    status: 'Active',
    hasWebsite: true,
    websiteUrl: 'https://lagoscentral.org',
    image: 'https://public.readdy.ai/ai/img_res/fbd0d03d81045f24c5e5dd89ddeb36fd.jpg',
    members: 850,
    livestream: true,
    coordinates: { lat: 6.6018, lng: 3.3515 },
  },
  {
    id: 2,
    name: 'Victoria Island SDA Church',
    location: 'Victoria Island, Lagos State',
    region: 'South West',
    state: 'Lagos',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Lagos Atlantic Conference',
    status: 'Active',
    hasWebsite: true,
    websiteUrl: 'https://visda.org',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20church%20building%20on%20Victoria%20Island%20Lagos%20with%20glass%20facade%20contemporary%20design%20palm%20trees%20and%20upscale%20urban%20setting%20with%20professional%20architectural%20photography%20showing%20clean%20lines%20and%20welcoming%20entrance&width=400&height=300&seq=church-lagos-002&orientation=landscape',
    members: 720,
    livestream: true,
    coordinates: { lat: 6.4281, lng: 3.4219 },
  },
  {
    id: 3,
    name: 'Surulere SDA Church',
    location: 'Surulere, Lagos State',
    region: 'South West',
    state: 'Lagos',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Lagos Mainland Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Nigerian%20church%20building%20in%20Surulere%20Lagos%20with%20classic%20architecture%20white%20painted%20walls%20red%20roof%20and%20steeple%20in%20residential%20neighborhood%20with%20warm%20afternoon%20lighting%20and%20welcoming%20atmosphere&width=400&height=300&seq=church-lagos-003&orientation=landscape',
    members: 640,
    livestream: true,
    coordinates: { lat: 6.4969, lng: 3.3539 },
  },
  {
    id: 4,
    name: 'Lekki SDA Church',
    location: 'Lekki, Lagos State',
    region: 'South West',
    state: 'Lagos',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Lagos Atlantic Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20church%20building%20in%20Lekki%20Lagos%20with%20modern%20tropical%20architecture%20open%20spaces%20natural%20ventilation%20landscaped%20gardens%20and%20coastal%20atmosphere%20with%20bright%20natural%20lighting%20and%20professional%20photography&width=400&height=300&seq=church-lagos-004&orientation=landscape',
    members: 580,
    livestream: true,
    coordinates: { lat: 6.4474, lng: 3.5406 },
  },

  // FCT Abuja - Northern Nigeria Union Conference (NNUC)
  {
    id: 5,
    name: 'Abuja Garki SDA Church',
    location: 'Garki, FCT Abuja',
    region: 'North Central',
    state: 'FCT',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Abuja Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20Adventist%20church%20building%20in%20Abuja%20Nigeria%20with%20modern%20design%20featuring%20elegant%20facade%20landscaped%20grounds%20and%20welcoming%20entrance%20with%20warm%20natural%20lighting%20and%20professional%20photography%20showing%20clean%20architectural%20lines&width=400&height=300&seq=church-abuja-002&orientation=landscape',
    members: 620,
    livestream: true,
    coordinates: { lat: 9.0579, lng: 7.4951 },
  },
  {
    id: 6,
    name: 'Wuse SDA Church',
    location: 'Wuse, FCT Abuja',
    region: 'North Central',
    state: 'FCT',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Abuja Conference',
    status: 'Active',
    hasWebsite: true,
    websiteUrl: 'https://wusesda.org',
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Wuse%20Abuja%20with%20contemporary%20architecture%20glass%20windows%20spacious%20parking%20and%20professional%20landscaping%20in%20upscale%20district%20with%20clear%20blue%20sky%20and%20welcoming%20design&width=400&height=300&seq=church-abuja-003&orientation=landscape',
    members: 780,
    livestream: true,
    coordinates: { lat: 9.0643, lng: 7.4820 },
  },
  {
    id: 7,
    name: 'Kubwa SDA Church',
    location: 'Kubwa, FCT Abuja',
    region: 'North Central',
    state: 'FCT',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Abuja Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20building%20in%20Kubwa%20Abuja%20with%20simple%20modern%20design%20white%20walls%20large%20windows%20and%20cross%20on%20facade%20in%20residential%20area%20with%20natural%20lighting%20and%20accessible%20entrance&width=400&height=300&seq=church-abuja-004&orientation=landscape',
    members: 520,
    livestream: false,
    coordinates: { lat: 9.1372, lng: 7.3447 },
  },

  // Oyo State - Western Nigeria Union Conference (WNUC)
  {
    id: 8,
    name: 'Ibadan Bodija SDA Church',
    location: 'Bodija, Oyo State',
    region: 'South West',
    state: 'Oyo',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Oyo Conference',
    status: 'Active',
    hasWebsite: true,
    websiteUrl: 'https://ibadanbodija.org',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Nigerian%20SDA%20church%20building%20in%20Ibadan%20with%20classic%20architecture%20featuring%20red%20brick%20exterior%20pitched%20roof%20and%20steeple%20surrounded%20by%20lush%20greenery%20with%20warm%20afternoon%20sunlight%20and%20welcoming%20atmosphere&width=400&height=300&seq=church-ibadan-003&orientation=landscape',
    members: 480,
    livestream: false,
    coordinates: { lat: 7.4340, lng: 3.9060 },
  },
  {
    id: 9,
    name: 'Ibadan Mokola SDA Church',
    location: 'Mokola, Oyo State',
    region: 'South West',
    state: 'Oyo',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Oyo Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Historic%20church%20building%20in%20Mokola%20Ibadan%20with%20traditional%20Nigerian%20architecture%20white%20painted%20walls%20arched%20windows%20and%20bell%20tower%20in%20established%20neighborhood%20with%20mature%20trees%20and%20welcoming%20entrance&width=400&height=300&seq=church-ibadan-004&orientation=landscape',
    members: 560,
    livestream: true,
    coordinates: { lat: 7.3964, lng: 3.9093 },
  },
  {
    id: 10,
    name: 'Ibadan Challenge SDA Church',
    location: 'Challenge, Oyo State',
    region: 'South West',
    state: 'Oyo',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Oyo Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20community%20church%20in%20Challenge%20Ibadan%20with%20contemporary%20design%20clean%20white%20exterior%20large%20sanctuary%20windows%20and%20landscaped%20compound%20with%20tropical%20plants%20and%20accessible%20pathways&width=400&height=300&seq=church-ibadan-005&orientation=landscape',
    members: 420,
    livestream: false,
    coordinates: { lat: 7.4378, lng: 3.9158 },
  },

  // Rivers State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 11,
    name: 'Port Harcourt Trans-Amadi SDA Church',
    location: 'Trans-Amadi, Rivers State',
    region: 'South South',
    state: 'Rivers',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Port Harcourt Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Port%20Harcourt%20Nigeria%20with%20contemporary%20tropical%20design%20featuring%20open%20architecture%20natural%20ventilation%20and%20covered%20outdoor%20spaces%20with%20palm%20trees%20and%20vibrant%20landscaping%20under%20clear%20sky&width=400&height=300&seq=church-portharcourt-004&orientation=landscape',
    members: 540,
    livestream: true,
    coordinates: { lat: 4.8156, lng: 7.0498 },
  },
  {
    id: 12,
    name: 'Port Harcourt Rumuola SDA Church',
    location: 'Rumuola, Rivers State',
    region: 'South South',
    state: 'Rivers',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Rivers East Conference',
    status: 'Active',
    hasWebsite: true,
    websiteUrl: 'https://rumuolasda.org',
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20church%20building%20in%20Rumuola%20Port%20Harcourt%20with%20modern%20architecture%20spacious%20sanctuary%20large%20windows%20and%20well-maintained%20grounds%20with%20tropical%20landscaping%20and%20welcoming%20entrance&width=400&height=300&seq=church-portharcourt-005&orientation=landscape',
    members: 680,
    livestream: true,
    coordinates: { lat: 4.8447, lng: 7.0134 },
  },
  {
    id: 13,
    name: 'Port Harcourt Eleme SDA Church',
    location: 'Eleme, Rivers State',
    region: 'South South',
    state: 'Rivers',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Rivers West Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20building%20in%20Eleme%20Rivers%20State%20with%20simple%20modern%20design%20white%20walls%20cross%20symbol%20and%20covered%20entrance%20in%20industrial%20town%20setting%20with%20natural%20lighting%20and%20accessible%20design&width=400&height=300&seq=church-portharcourt-006&orientation=landscape',
    members: 380,
    livestream: false,
    coordinates: { lat: 4.7833, lng: 7.1500 },
  },

  // Kano State - Northern Nigeria Union Conference (NNUC)
  {
    id: 14,
    name: 'Kano Central SDA Church',
    location: 'Sabon Gari, Kano State',
    region: 'North West',
    state: 'Kano',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Simple%20Adventist%20church%20building%20in%20northern%20Nigeria%20with%20modest%20architecture%20featuring%20clean%20white%20walls%20arched%20windows%20and%20cross%20on%20facade%20in%20urban%20setting%20with%20warm%20lighting%20and%20welcoming%20entrance&width=400&height=300&seq=church-kano-005&orientation=landscape',
    members: 280,
    livestream: false,
    coordinates: { lat: 12.0022, lng: 8.5919 },
  },
  {
    id: 15,
    name: 'Kano Nassarawa SDA Church',
    location: 'Nassarawa, Kano State',
    region: 'North West',
    state: 'Kano',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Small%20community%20church%20in%20Nassarawa%20Kano%20with%20simple%20architecture%20white%20painted%20walls%20small%20windows%20and%20modest%20entrance%20in%20residential%20neighborhood%20with%20natural%20lighting%20and%20accessible%20design&width=400&height=300&seq=church-kano-006&orientation=landscape',
    members: 220,
    livestream: false,
    coordinates: { lat: 11.9950, lng: 8.5450 },
  },

  // Enugu State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 16,
    name: 'Enugu Independence Layout SDA Church',
    location: 'Independence Layout, Enugu State',
    region: 'South East',
    state: 'Enugu',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Enugu Conference',
    status: 'Active',
    hasWebsite: true,
    websiteUrl: 'https://enuguindependence.org',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20SDA%20church%20in%20Enugu%20Nigeria%20with%20elegant%20modern%20architecture%20featuring%20large%20sanctuary%20glass%20windows%20and%20well-maintained%20compound%20with%20tropical%20plants%20and%20paved%20walkways%20under%20bright%20daylight&width=400&height=300&seq=church-enugu-006&orientation=landscape',
    members: 720,
    livestream: true,
    coordinates: { lat: 6.4474, lng: 7.5248 },
  },
  {
    id: 17,
    name: 'Enugu New Haven SDA Church',
    location: 'New Haven, Enugu State',
    region: 'South East',
    state: 'Enugu',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Enugu Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20church%20building%20in%20New%20Haven%20Enugu%20with%20classic%20Nigerian%20architecture%20red%20brick%20walls%20pitched%20roof%20and%20bell%20tower%20in%20established%20residential%20area%20with%20mature%20trees%20and%20welcoming%20atmosphere&width=400&height=300&seq=church-enugu-007&orientation=landscape',
    members: 580,
    livestream: true,
    coordinates: { lat: 6.4698, lng: 7.5155 },
  },

  // Kaduna State - Northern Nigeria Union Conference (NNUC)
  {
    id: 18,
    name: 'Kaduna Central SDA Church',
    location: 'Kaduna South, Kaduna State',
    region: 'North West',
    state: 'Kaduna',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Kaduna%20Nigeria%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20and%20cross%20symbol%20in%20urban%20setting%20with%20natural%20lighting%20and%20accessible%20entrance&width=400&height=300&seq=church-kaduna-001&orientation=landscape',
    members: 460,
    livestream: true,
    coordinates: { lat: 10.5105, lng: 7.4165 },
  },
  {
    id: 19,
    name: 'Kaduna Barnawa SDA Church',
    location: 'Barnawa, Kaduna State',
    region: 'North West',
    state: 'Kaduna',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Barnawa%20Kaduna%20with%20simple%20modern%20design%20clean%20white%20walls%20arched%20entrance%20and%20modest%20landscaping%20in%20residential%20neighborhood%20with%20warm%20afternoon%20lighting&width=400&height=300&seq=church-kaduna-002&orientation=landscape',
    members: 340,
    livestream: false,
    coordinates: { lat: 10.4806, lng: 7.4383 },
  },

  // Ogun State - Western Nigeria Union Conference (WNUC)
  {
    id: 20,
    name: 'Abeokuta Oke-Ilewo SDA Church',
    location: 'Oke-Ilewo, Ogun State',
    region: 'South West',
    state: 'Ogun',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Ogun Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20church%20building%20in%20Abeokuta%20Ogun%20State%20with%20classic%20Nigerian%20architecture%20white%20painted%20walls%20red%20roof%20and%20steeple%20on%20hillside%20location%20with%20lush%20vegetation%20and%20welcoming%20entrance&width=400&height=300&seq=church-ogun-001&orientation=landscape',
    members: 520,
    livestream: true,
    coordinates: { lat: 7.1475, lng: 3.3619 },
  },
  {
    id: 21,
    name: 'Abeokuta Isale-Igbein SDA Church',
    location: 'Isale-Igbein, Ogun State',
    region: 'South West',
    state: 'Ogun',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Ogun Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Historic%20church%20building%20in%20Isale-Igbein%20Abeokuta%20with%20traditional%20architecture%20white%20walls%20arched%20windows%20and%20bell%20tower%20in%20established%20neighborhood%20with%20mature%20trees%20and%20welcoming%20atmosphere&width=400&height=300&seq=church-ogun-002&orientation=landscape',
    members: 440,
    livestream: false,
    coordinates: { lat: 7.1575, lng: 3.3469 },
  },

  // Anambra State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 22,
    name: 'Awka SDA Church',
    location: 'Awka, Anambra State',
    region: 'South East',
    state: 'Anambra',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Anambra Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Awka%20Anambra%20with%20contemporary%20architecture%20clean%20white%20exterior%20large%20sanctuary%20windows%20and%20landscaped%20compound%20with%20tropical%20plants%20and%20paved%20walkways&width=400&height=300&seq=church-anambra-001&orientation=landscape',
    members: 480,
    livestream: true,
    coordinates: { lat: 6.2104, lng: 7.0719 },
  },
  {
    id: 23,
    name: 'Onitsha SDA Church',
    location: 'Onitsha, Anambra State',
    region: 'South East',
    state: 'Anambra',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Anambra Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20church%20building%20in%20Onitsha%20Anambra%20with%20modern%20design%20spacious%20sanctuary%20large%20windows%20and%20well-maintained%20grounds%20in%20commercial%20city%20setting%20with%20natural%20lighting&width=400&height=300&seq=church-anambra-002&orientation=landscape',
    members: 620,
    livestream: true,
    coordinates: { lat: 6.1499, lng: 6.7860 },
  },

  // Abia State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 24,
    name: 'Aba North SDA Church',
    location: 'Aba North, Abia State',
    region: 'South East',
    state: 'Abia',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Aba North Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Aba%20North%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20and%20cross%20symbol%20in%20commercial%20area%20with%20natural%20lighting%20and%20accessible%20entrance&width=400&height=300&seq=church-abia-001&orientation=landscape',
    members: 580,
    livestream: true,
    coordinates: { lat: 5.1406, lng: 7.3670 },
  },
  {
    id: 25,
    name: 'Aba South SDA Church',
    location: 'Aba South, Abia State',
    region: 'South East',
    state: 'Abia',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Aba South Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Aba%20South%20with%20simple%20modern%20design%20clean%20walls%20large%20sanctuary%20and%20modest%20landscaping%20in%20busy%20commercial%20district%20with%20welcoming%20entrance&width=400&height=300&seq=church-abia-002&orientation=landscape',
    members: 520,
    livestream: true,
    coordinates: { lat: 5.0892, lng: 7.3667 },
  },
  {
    id: 26,
    name: 'Umuahia SDA Church',
    location: 'Umuahia, Abia State',
    region: 'South East',
    state: 'Abia',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Abia North-Central Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20church%20building%20in%20Umuahia%20Abia%20State%20with%20classic%20architecture%20white%20painted%20walls%20pitched%20roof%20and%20steeple%20in%20state%20capital%20setting%20with%20lush%20greenery&width=400&height=300&seq=church-abia-003&orientation=landscape',
    members: 460,
    livestream: false,
    coordinates: { lat: 5.5265, lng: 7.4896 },
  },

  // Imo State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 27,
    name: 'Owerri SDA Church',
    location: 'Owerri, Imo State',
    region: 'South East',
    state: 'Imo',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Imo Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Owerri%20Imo%20State%20with%20contemporary%20architecture%20clean%20white%20exterior%20large%20sanctuary%20windows%20and%20landscaped%20compound%20in%20state%20capital%20setting&width=400&height=300&seq=church-imo-001&orientation=landscape',
    members: 640,
    livestream: true,
    coordinates: { lat: 5.4840, lng: 7.0351 },
  },
  {
    id: 28,
    name: 'Orlu SDA Church',
    location: 'Orlu, Imo State',
    region: 'South East',
    state: 'Imo',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Imo Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Orlu%20Imo%20State%20with%20simple%20modern%20design%20white%20walls%20arched%20windows%20and%20modest%20entrance%20in%20town%20setting%20with%20natural%20lighting&width=400&height=300&seq=church-imo-002&orientation=landscape',
    members: 380,
    livestream: false,
    coordinates: { lat: 5.7956, lng: 7.0378 },
  },

  // Akwa Ibom State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 29,
    name: 'Uyo SDA Church',
    location: 'Uyo, Akwa Ibom State',
    region: 'South South',
    state: 'Akwa Ibom',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Akwa Ibom Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Uyo%20Akwa%20Ibom%20with%20contemporary%20tropical%20architecture%20open%20spaces%20natural%20ventilation%20and%20landscaped%20grounds%20in%20state%20capital%20with%20palm%20trees&width=400&height=300&seq=church-akwaibom-001&orientation=landscape',
    members: 720,
    livestream: true,
    coordinates: { lat: 5.0378, lng: 7.9085 },
  },
  {
    id: 30,
    name: 'Ikot Ekpene SDA Church',
    location: 'Ikot Ekpene, Akwa Ibom State',
    region: 'South South',
    state: 'Akwa Ibom',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Akwa Ibom Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20church%20building%20in%20Ikot%20Ekpene%20with%20classic%20Nigerian%20architecture%20white%20walls%20red%20roof%20and%20steeple%20in%20historic%20town%20setting%20with%20mature%20trees&width=400&height=300&seq=church-akwaibom-002&orientation=landscape',
    members: 420,
    livestream: false,
    coordinates: { lat: 5.1818, lng: 7.7167 },
  },

  // Cross River State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 31,
    name: 'Calabar SDA Church',
    location: 'Calabar, Cross River State',
    region: 'South South',
    state: 'Cross River',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Cross River Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Calabar%20Cross%20River%20with%20contemporary%20coastal%20architecture%20open%20design%20natural%20ventilation%20and%20tropical%20landscaping%20near%20waterfront%20setting&width=400&height=300&seq=church-crossriver-001&orientation=landscape',
    members: 680,
    livestream: true,
    coordinates: { lat: 4.9517, lng: 8.3417 },
  },
  {
    id: 32,
    name: 'Ogoja SDA Church',
    location: 'Ogoja, Cross River State',
    region: 'South South',
    state: 'Cross River',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Cross River Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Simple%20community%20church%20in%20Ogoja%20Cross%20River%20with%20modest%20architecture%20white%20painted%20walls%20small%20windows%20and%20accessible%20entrance%20in%20rural%20town%20setting&width=400&height=300&seq=church-crossriver-002&orientation=landscape',
    members: 280,
    livestream: false,
    coordinates: { lat: 6.6582, lng: 8.7979 },
  },

  // Delta State - Western Nigeria Union Conference (WNUC)
  {
    id: 33,
    name: 'Warri SDA Church',
    location: 'Warri, Delta State',
    region: 'South South',
    state: 'Delta',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Edo-Delta Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Warri%20Delta%20State%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20and%20covered%20entrance%20in%20oil%20city%20setting%20with%20tropical%20vegetation&width=400&height=300&seq=church-delta-001&orientation=landscape',
    members: 560,
    livestream: true,
    coordinates: { lat: 5.5167, lng: 5.7500 },
  },
  {
    id: 34,
    name: 'Asaba SDA Church',
    location: 'Asaba, Delta State',
    region: 'South South',
    state: 'Delta',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Edo-Delta Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20church%20building%20in%20Asaba%20Delta%20State%20with%20modern%20design%20spacious%20sanctuary%20large%20windows%20and%20well-maintained%20grounds%20in%20state%20capital%20setting&width=400&height=300&seq=church-delta-002&orientation=landscape',
    members: 480,
    livestream: true,
    coordinates: { lat: 6.1987, lng: 6.7337 },
  },

  // Edo State - Western Nigeria Union Conference (WNUC)
  {
    id: 35,
    name: 'Benin City Central SDA Church',
    location: 'Benin City, Edo State',
    region: 'South South',
    state: 'Edo',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Edo-Delta Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Historic%20church%20building%20in%20Benin%20City%20with%20traditional%20architecture%20white%20painted%20walls%20arched%20windows%20and%20bell%20tower%20in%20ancient%20city%20setting%20with%20mature%20trees&width=400&height=300&seq=church-edo-001&orientation=landscape',
    members: 620,
    livestream: true,
    coordinates: { lat: 6.3350, lng: 5.6037 },
  },
  {
    id: 36,
    name: 'Benin City Ugbowo SDA Church',
    location: 'Ugbowo, Edo State',
    region: 'South South',
    state: 'Edo',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Edo-Delta Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Ugbowo%20Benin%20City%20with%20contemporary%20architecture%20clean%20white%20exterior%20large%20sanctuary%20and%20landscaped%20compound%20near%20university%20area&width=400&height=300&seq=church-edo-002&orientation=landscape',
    members: 540,
    livestream: true,
    coordinates: { lat: 6.4023, lng: 5.6173 },
  },

  // Bayelsa State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 37,
    name: 'Yenagoa SDA Church',
    location: 'Yenagoa, Bayelsa State',
    region: 'South South',
    state: 'Bayelsa',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Bayelsa Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Yenagoa%20Bayelsa%20with%20contemporary%20tropical%20architecture%20elevated%20foundation%20natural%20ventilation%20and%20waterfront%20setting%20with%20palm%20trees&width=400&height=300&seq=church-bayelsa-001&orientation=landscape',
    members: 380,
    livestream: false,
    coordinates: { lat: 4.9267, lng: 6.2676 },
  },
  {
    id: 38,
    name: 'Brass SDA Church',
    location: 'Brass, Bayelsa State',
    region: 'South South',
    state: 'Bayelsa',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Bayelsa Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Small%20coastal%20church%20in%20Brass%20Bayelsa%20with%20simple%20architecture%20elevated%20structure%20white%20walls%20and%20modest%20entrance%20in%20riverine%20community%20setting&width=400&height=300&seq=church-bayelsa-002&orientation=landscape',
    members: 180,
    livestream: false,
    coordinates: { lat: 4.3067, lng: 6.2417 },
  },

  // Ebonyi State - Eastern Nigeria Union Conference (ENUC)
  {
    id: 39,
    name: 'Abakaliki SDA Church',
    location: 'Abakaliki, Ebonyi State',
    region: 'South East',
    state: 'Ebonyi',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Abonyi Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Abakaliki%20Ebonyi%20State%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20and%20cross%20symbol%20in%20state%20capital%20setting&width=400&height=300&seq=church-ebonyi-001&orientation=landscape',
    members: 420,
    livestream: true,
    coordinates: { lat: 6.3249, lng: 8.1137 },
  },
  {
    id: 40,
    name: 'Afikpo SDA Church',
    location: 'Afikpo, Ebonyi State',
    region: 'South East',
    state: 'Ebonyi',
    union: 'Eastern Nigeria Union Conference (ENUC)',
    conference: 'Abonyi Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Afikpo%20Ebonyi%20with%20simple%20modern%20design%20white%20walls%20arched%20entrance%20and%20modest%20landscaping%20in%20town%20setting&width=400&height=300&seq=church-ebonyi-002&orientation=landscape',
    members: 320,
    livestream: false,
    coordinates: { lat: 5.8931, lng: 7.9361 },
  },

  // Plateau State - Northern Nigeria Union Conference (NNUC)
  {
    id: 41,
    name: 'Jos Central SDA Church',
    location: 'Jos, Plateau State',
    region: 'North Central',
    state: 'Plateau',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Plateau Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Jos%20Plateau%20State%20with%20contemporary%20architecture%20white%20exterior%20large%20sanctuary%20windows%20in%20highland%20city%20setting%20with%20cool%20climate%20vegetation&width=400&height=300&seq=church-plateau-001&orientation=landscape',
    members: 680,
    livestream: true,
    coordinates: { lat: 9.8965, lng: 8.8583 },
  },
  {
    id: 42,
    name: 'Jos Bukuru SDA Church',
    location: 'Bukuru, Plateau State',
    region: 'North Central',
    state: 'Plateau',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Plateau Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Bukuru%20Jos%20with%20simple%20modern%20design%20clean%20white%20walls%20large%20windows%20and%20accessible%20entrance%20in%20mining%20town%20setting&width=400&height=300&seq=church-plateau-002&orientation=landscape',
    members: 520,
    livestream: true,
    coordinates: { lat: 9.7989, lng: 8.8667 },
  },

  // Benue State - Northern Nigeria Union Conference (NNUC)
  {
    id: 43,
    name: 'Makurdi SDA Church',
    location: 'Makurdi, Benue State',
    region: 'North Central',
    state: 'Benue',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Benue Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Makurdi%20Benue%20State%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20in%20state%20capital%20setting%20near%20river&width=400&height=300&seq=church-benue-001&orientation=landscape',
    members: 560,
    livestream: true,
    coordinates: { lat: 7.7336, lng: 8.5211 },
  },
  {
    id: 44,
    name: 'Gboko SDA Church',
    location: 'Gboko, Benue State',
    region: 'North Central',
    state: 'Benue',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Benue Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20church%20building%20in%20Gboko%20Benue%20with%20classic%20architecture%20white%20painted%20walls%20pitched%20roof%20in%20agricultural%20town%20setting&width=400&height=300&seq=church-benue-002&orientation=landscape',
    members: 380,
    livestream: false,
    coordinates: { lat: 7.3230, lng: 9.0000 },
  },

  // Nasarawa State - Northern Nigeria Union Conference (NNUC)
  {
    id: 45,
    name: 'Lafia SDA Church',
    location: 'Lafia, Nasarawa State',
    region: 'North Central',
    state: 'Nasarawa',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North Central Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Lafia%20Nasarawa%20State%20with%20contemporary%20architecture%20clean%20white%20exterior%20large%20sanctuary%20in%20state%20capital%20setting&width=400&height=300&seq=church-nasarawa-001&orientation=landscape',
    members: 420,
    livestream: true,
    coordinates: { lat: 8.4833, lng: 8.5167 },
  },
  {
    id: 46,
    name: 'Keffi SDA Church',
    location: 'Keffi, Nasarawa State',
    region: 'North Central',
    state: 'Nasarawa',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North Central Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Keffi%20Nasarawa%20with%20simple%20modern%20design%20white%20walls%20arched%20windows%20in%20historic%20town%20setting&width=400&height=300&seq=church-nasarawa-002&orientation=landscape',
    members: 320,
    livestream: false,
    coordinates: { lat: 8.8500, lng: 7.8667 },
  },

  // Niger State - Northern Nigeria Union Conference (NNUC)
  {
    id: 47,
    name: 'Minna SDA Church',
    location: 'Minna, Niger State',
    region: 'North Central',
    state: 'Niger',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North Central Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Minna%20Niger%20State%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20in%20state%20capital%20setting&width=400&height=300&seq=church-niger-001&orientation=landscape',
    members: 480,
    livestream: true,
    coordinates: { lat: 9.6139, lng: 6.5569 },
  },
  {
    id: 48,
    name: 'Suleja SDA Church',
    location: 'Suleja, Niger State',
    region: 'North Central',
    state: 'Niger',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North Central Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20church%20building%20in%20Suleja%20Niger%20State%20with%20modern%20design%20clean%20white%20walls%20large%20sanctuary%20near%20Abuja%20setting&width=400&height=300&seq=church-niger-002&orientation=landscape',
    members: 420,
    livestream: true,
    coordinates: { lat: 9.1806, lng: 7.1794 },
  },

  // Kogi State - Western Nigeria Union Conference (WNUC)
  {
    id: 49,
    name: 'Lokoja SDA Church',
    location: 'Lokoja, Kogi State',
    region: 'North Central',
    state: 'Kogi',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Kogi Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Lokoja%20Kogi%20State%20at%20confluence%20of%20rivers%20with%20contemporary%20architecture%20white%20exterior%20in%20historic%20state%20capital&width=400&height=300&seq=church-kogi-001&orientation=landscape',
    members: 380,
    livestream: false,
    coordinates: { lat: 7.7974, lng: 6.7406 },
  },
  {
    id: 50,
    name: 'Okene SDA Church',
    location: 'Okene, Kogi State',
    region: 'North Central',
    state: 'Kogi',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Kogi Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Okene%20Kogi%20with%20simple%20modern%20design%20white%20walls%20modest%20entrance%20in%20town%20setting&width=400&height=300&seq=church-kogi-002&orientation=landscape',
    members: 280,
    livestream: false,
    coordinates: { lat: 7.5500, lng: 6.2333 },
  },

  // Kwara State - Western Nigeria Union Conference (WNUC)
  {
    id: 51,
    name: 'Ilorin Central SDA Church',
    location: 'Ilorin, Kwara State',
    region: 'North Central',
    state: 'Kwara',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Kwara Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Ilorin%20Kwara%20State%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20in%20state%20capital%20setting&width=400&height=300&seq=church-kwara-001&orientation=landscape',
    members: 520,
    livestream: true,
    coordinates: { lat: 8.4799, lng: 4.5418 },
  },
  {
    id: 52,
    name: 'Offa SDA Church',
    location: 'Offa, Kwara State',
    region: 'North Central',
    state: 'Kwara',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Kwara Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20church%20building%20in%20Offa%20Kwara%20with%20classic%20architecture%20white%20painted%20walls%20in%20historic%20town%20setting&width=400&height=300&seq=church-kwara-002&orientation=landscape',
    members: 340,
    livestream: false,
    coordinates: { lat: 8.1500, lng: 4.7167 },
  },

  // Ekiti State - Western Nigeria Union Conference (WNUC)
  {
    id: 53,
    name: 'Ado-Ekiti SDA Church',
    location: 'Ado-Ekiti, Ekiti State',
    region: 'South West',
    state: 'Ekiti',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Ekiti Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Ado-Ekiti%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20in%20hilly%20state%20capital%20setting&width=400&height=300&seq=church-ekiti-001&orientation=landscape',
    members: 460,
    livestream: true,
    coordinates: { lat: 7.6211, lng: 5.2200 },
  },
  {
    id: 54,
    name: 'Ikere-Ekiti SDA Church',
    location: 'Ikere-Ekiti, Ekiti State',
    region: 'South West',
    state: 'Ekiti',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Ekiti Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Ikere-Ekiti%20with%20simple%20modern%20design%20white%20walls%20arched%20entrance%20in%20town%20setting&width=400&height=300&seq=church-ekiti-002&orientation=landscape',
    members: 320,
    livestream: false,
    coordinates: { lat: 7.4967, lng: 5.2300 },
  },

  // Ondo State - Western Nigeria Union Conference (WNUC)
  {
    id: 55,
    name: 'Akure SDA Church',
    location: 'Akure, Ondo State',
    region: 'South West',
    state: 'Ondo',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Ondo Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Akure%20Ondo%20State%20with%20contemporary%20architecture%20white%20exterior%20large%20sanctuary%20in%20state%20capital%20setting&width=400&height=300&seq=church-ondo-001&orientation=landscape',
    members: 540,
    livestream: true,
    coordinates: { lat: 7.2571, lng: 5.2058 },
  },
  {
    id: 56,
    name: 'Ondo Town SDA Church',
    location: 'Ondo Town, Ondo State',
    region: 'South West',
    state: 'Ondo',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Ondo Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Historic%20church%20building%20in%20Ondo%20Town%20with%20traditional%20architecture%20white%20painted%20walls%20in%20ancient%20Yoruba%20town%20setting&width=400&height=300&seq=church-ondo-002&orientation=landscape',
    members: 380,
    livestream: false,
    coordinates: { lat: 7.0936, lng: 4.8353 },
  },

  // Osun State - Western Nigeria Union Conference (WNUC)
  {
    id: 57,
    name: 'Osogbo SDA Church',
    location: 'Osogbo, Osun State',
    region: 'South West',
    state: 'Osun',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Osun Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Osogbo%20Osun%20State%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20in%20state%20capital%20setting&width=400&height=300&seq=church-osun-001&orientation=landscape',
    members: 480,
    livestream: true,
    coordinates: { lat: 7.7667, lng: 4.5667 },
  },
  {
    id: 58,
    name: 'Ile-Ife SDA Church',
    location: 'Ile-Ife, Osun State',
    region: 'South West',
    state: 'Osun',
    union: 'Western Nigeria Union Conference (WNUC)',
    conference: 'Osun Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20church%20building%20in%20Ile-Ife%20Osun%20with%20classic%20architecture%20white%20walls%20in%20ancient%20Yoruba%20city%20setting&width=400&height=300&seq=church-osun-002&orientation=landscape',
    members: 420,
    livestream: true,
    coordinates: { lat: 7.4667, lng: 4.5667 },
  },

  // Bauchi State - Northern Nigeria Union Conference (NNUC)
  {
    id: 59,
    name: 'Bauchi Central SDA Church',
    location: 'Bauchi, Bauchi State',
    region: 'North East',
    state: 'Bauchi',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Bauchi Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Bauchi%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20large%20windows%20in%20northern%20Nigeria%20setting&width=400&height=300&seq=church-bauchi-001&orientation=landscape',
    members: 380,
    livestream: false,
    coordinates: { lat: 10.3158, lng: 9.8442 },
  },
  {
    id: 60,
    name: 'Azare SDA Church',
    location: 'Azare, Bauchi State',
    region: 'North East',
    state: 'Bauchi',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Bauchi Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Simple%20community%20church%20in%20Azare%20Bauchi%20with%20modest%20architecture%20white%20walls%20small%20windows%20in%20town%20setting&width=400&height=300&seq=church-bauchi-002&orientation=landscape',
    members: 240,
    livestream: false,
    coordinates: { lat: 11.6833, lng: 10.1833 },
  },

  // Gombe State - Northern Nigeria Union Conference (NNUC)
  {
    id: 61,
    name: 'Gombe Central SDA Church',
    location: 'Gombe, Gombe State',
    region: 'North East',
    state: 'Gombe',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Gombe Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Gombe%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20in%20northern%20Nigeria%20setting&width=400&height=300&seq=church-gombe-001&orientation=landscape',
    members: 340,
    livestream: false,
    coordinates: { lat: 10.2897, lng: 11.1711 },
  },
  {
    id: 62,
    name: 'Dukku SDA Church',
    location: 'Dukku, Gombe State',
    region: 'North East',
    state: 'Gombe',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Gombe Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Small%20community%20church%20in%20Dukku%20Gombe%20with%20simple%20architecture%20white%20walls%20modest%20entrance%20in%20rural%20town&width=400&height=300&seq=church-gombe-002&orientation=landscape',
    members: 220,
    livestream: false,
    coordinates: { lat: 10.8167, lng: 10.7667 },
  },

  // Adamawa State - Northern Nigeria Union Conference (NNUC)
  {
    id: 63,
    name: 'Yola SDA Church',
    location: 'Yola, Adamawa State',
    region: 'North East',
    state: 'Adamawa',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Adamawa Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Yola%20Adamawa%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20near%20river%20setting&width=400&height=300&seq=church-adamawa-001&orientation=landscape',
    members: 360,
    livestream: false,
    coordinates: { lat: 9.2094, lng: 12.4753 },
  },
  {
    id: 64,
    name: 'Mubi SDA Church',
    location: 'Mubi, Adamawa State',
    region: 'North East',
    state: 'Adamawa',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Adamawa Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Mubi%20Adamawa%20with%20simple%20modern%20design%20white%20walls%20in%20border%20town%20setting&width=400&height=300&seq=church-adamawa-002&orientation=landscape',
    members: 260,
    livestream: false,
    coordinates: { lat: 10.2667, lng: 13.2667 },
  },

  // Taraba State - Northern Nigeria Union Conference (NNUC)
  {
    id: 65,
    name: 'Jalingo SDA Church',
    location: 'Jalingo, Taraba State',
    region: 'North East',
    state: 'Taraba',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Taraba Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Jalingo%20Taraba%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20in%20hilly%20setting&width=400&height=300&seq=church-taraba-001&orientation=landscape',
    members: 320,
    livestream: false,
    coordinates: { lat: 8.8833, lng: 11.3667 },
  },
  {
    id: 66,
    name: 'Wukari SDA Church',
    location: 'Wukari, Taraba State',
    region: 'North East',
    state: 'Taraba',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Taraba Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Wukari%20Taraba%20with%20simple%20architecture%20white%20walls%20in%20agricultural%20town%20setting&width=400&height=300&seq=church-taraba-002&orientation=landscape',
    members: 240,
    livestream: false,
    coordinates: { lat: 7.8667, lng: 9.7833 },
  },

  // Borno State - Northern Nigeria Union Conference (NNUC)
  {
    id: 67,
    name: 'Maiduguri SDA Church',
    location: 'Maiduguri, Borno State',
    region: 'North East',
    state: 'Borno',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Borno Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Simple%20church%20building%20in%20Maiduguri%20Borno%20State%20capital%20with%20modest%20architecture%20white%20walls%20in%20northern%20Nigeria%20setting&width=400&height=300&seq=church-borno-001&orientation=landscape',
    members: 280,
    livestream: false,
    coordinates: { lat: 11.8333, lng: 13.1500 },
  },
  {
    id: 68,
    name: 'Biu SDA Church',
    location: 'Biu, Borno State',
    region: 'North East',
    state: 'Borno',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'Borno Mission',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Small%20community%20church%20in%20Biu%20Borno%20with%20simple%20architecture%20white%20walls%20modest%20entrance%20in%20town%20setting&width=400&height=300&seq=church-borno-002&orientation=landscape',
    members: 180,
    livestream: false,
    coordinates: { lat: 10.6167, lng: 12.1833 },
  },

  // Yobe State - Northern Nigeria Union Conference (NNUC)
  {
    id: 69,
    name: 'Damaturu SDA Church',
    location: 'Damaturu, Yobe State',
    region: 'North East',
    state: 'Yobe',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-East Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Damaturu%20Yobe%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20in%20northern%20Nigeria%20setting&width=400&height=300&seq=church-yobe-001&orientation=landscape',
    members: 260,
    livestream: false,
    coordinates: { lat: 11.7500, lng: 11.9667 },
  },
  {
    id: 70,
    name: 'Potiskum SDA Church',
    location: 'Potiskum, Yobe State',
    region: 'North East',
    state: 'Yobe',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-East Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Potiskum%20Yobe%20with%20simple%20modern%20design%20white%20walls%20in%20commercial%20town%20setting&width=400&height=300&seq=church-yobe-002&orientation=landscape',
    members: 200,
    livestream: false,
    coordinates: { lat: 11.7167, lng: 11.0667 },
  },

  // Jigawa State - Northern Nigeria Union Conference (NNUC)
  {
    id: 71,
    name: 'Dutse SDA Church',
    location: 'Dutse, Jigawa State',
    region: 'North West',
    state: 'Jigawa',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Dutse%20Jigawa%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20in%20northern%20Nigeria%20setting&width=400&height=300&seq=church-jigawa-001&orientation=landscape',
    members: 240,
    livestream: false,
    coordinates: { lat: 11.7667, lng: 9.3333 },
  },
  {
    id: 72,
    name: 'Hadejia SDA Church',
    location: 'Hadejia, Jigawa State',
    region: 'North West',
    state: 'Jigawa',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Simple%20community%20church%20in%20Hadejia%20Jigawa%20with%20modest%20architecture%20white%20walls%20in%20historic%20town%20setting&width=400&height=300&seq=church-jigawa-002&orientation=landscape',
    members: 180,
    livestream: false,
    coordinates: { lat: 12.4500, lng: 10.0500 },
  },

  // Katsina State - Northern Nigeria Union Conference (NNUC)
  {
    id: 73,
    name: 'Katsina Central SDA Church',
    location: 'Katsina, Katsina State',
    region: 'North West',
    state: 'Katsina',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Katsina%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20in%20northern%20Nigeria%20setting&width=400&height=300&seq=church-katsina-001&orientation=landscape',
    members: 260,
    livestream: false,
    coordinates: { lat: 12.9833, lng: 7.6000 },
  },
  {
    id: 74,
    name: 'Daura SDA Church',
    location: 'Daura, Katsina State',
    region: 'North West',
    state: 'Katsina',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Simple%20community%20church%20in%20Daura%20Katsina%20with%20modest%20architecture%20white%20walls%20in%20historic%20town%20setting&width=400&height=300&seq=church-katsina-002&orientation=landscape',
    members: 200,
    livestream: false,
    coordinates: { lat: 13.0333, lng: 8.3167 },
  },

  // Sokoto State - Northern Nigeria Union Conference (NNUC)
  {
    id: 75,
    name: 'Sokoto Central SDA Church',
    location: 'Sokoto, Sokoto State',
    region: 'North West',
    state: 'Sokoto',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Sokoto%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20in%20northern%20Nigeria%20setting&width=400&height=300&seq=church-sokoto-001&orientation=landscape',
    members: 240,
    livestream: false,
    coordinates: { lat: 13.0622, lng: 5.2339 },
  },
  {
    id: 76,
    name: 'Gwadabawa SDA Church',
    location: 'Gwadabawa, Sokoto State',
    region: 'North West',
    state: 'Sokoto',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Small%20community%20church%20in%20Gwadabawa%20Sokoto%20with%20simple%20architecture%20white%20walls%20in%20rural%20town%20setting&width=400&height=300&seq=church-sokoto-002&orientation=landscape',
    members: 160,
    livestream: false,
    coordinates: { lat: 13.3500, lng: 5.2333 },
  },

  // Zamfara State - Northern Nigeria Union Conference (NNUC)
  {
    id: 77,
    name: 'Gusau SDA Church',
    location: 'Gusau, Zamfara State',
    region: 'North West',
    state: 'Zamfara',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Gusau%20Zamfara%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20in%20northern%20Nigeria%20setting&width=400&height=300&seq=church-zamfara-001&orientation=landscape',
    members: 220,
    livestream: false,
    coordinates: { lat: 12.1667, lng: 6.6667 },
  },
  {
    id: 78,
    name: 'Kaura Namoda SDA Church',
    location: 'Kaura Namoda, Zamfara State',
    region: 'North West',
    state: 'Zamfara',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Kaura%20Namoda%20Zamfara%20with%20simple%20modern%20design%20white%20walls%20in%20town%20setting&width=400&height=300&seq=church-zamfara-002&orientation=landscape',
    members: 180,
    livestream: false,
    coordinates: { lat: 12.5833, lng: 6.5833 },
  },

  // Kebbi State - Northern Nigeria Union Conference (NNUC)
  {
    id: 79,
    name: 'Birnin Kebbi SDA Church',
    location: 'Birnin Kebbi, Kebbi State',
    region: 'North West',
    state: 'Kebbi',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20church%20building%20in%20Birnin%20Kebbi%20State%20capital%20with%20contemporary%20architecture%20white%20exterior%20near%20river%20setting&width=400&height=300&seq=church-kebbi-001&orientation=landscape',
    members: 240,
    livestream: false,
    coordinates: { lat: 12.4500, lng: 4.2000 },
  },
  {
    id: 80,
    name: 'Argungu SDA Church',
    location: 'Argungu, Kebbi State',
    region: 'North West',
    state: 'Kebbi',
    union: 'Northern Nigeria Union Conference (NNUC)',
    conference: 'North-West Nigeria Conference',
    status: 'Active',
    hasWebsite: false,
    image: 'https://readdy.ai/api/search-image?query=Community%20church%20in%20Argungu%20Kebbi%20with%20simple%20architecture%20white%20walls%20in%20fishing%20town%20setting&width=400&height=300&seq=church-kebbi-002&orientation=landscape',
    members: 180,
    livestream: false,
    coordinates: { lat: 12.7500, lng: 4.5167 },
  },
];
